import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useUpdateStatus = () => {
  const mutation = useMutation((formData) => {
    return axiosClient.post(
      `/Company/EnableOrDisableCompany?companyId=${formData.companyId}&isEnabled=${formData.isEnabled}`
    );
  });
  return mutation;
};
export default useUpdateStatus;
